(function(module) {
  'use strict';
  module
    .controller('profileFieldsController', ['$scope', '$filter', '$window', '$state', 'ngDialog', 'toastr',
      'progressBar', 'profileFieldService', 'commonDialogMessage',
      'clientSelectService', 'agencySelectService', 'uiGridConstants', 'toastFactory',
      function($scope, $filter, $window, $state, ngDialog, toastr, progressBar, profileFieldService,
        commonDialogMessage,
        clientSelectService, agencySelectService, uiGridConstants, toastFactory) {
        const progress = progressBar.getProgressBar();
        const storage = $window.localStorage;
        $scope.formData = {};
        $scope.profileField = {};
        $scope.viewData = {};
        $scope.validate = {};
        $scope.profileField = {
          Id: 0,
          Name: null,
          AgencyDefinition: null,
          OrganizationId: null,
          IsRequired: false,
          FieldOption: {
            Id: 0,
            ProfileFieldId: 0,
            Name: null,
          },
        };
        $scope.formData = {
          Id: 0,
          Name: null,
          AgencyDefinition: null,
          OrganizationId: null,
          IsRequired: false,
          FieldOption: {
            Id: 0,
            ProfileFieldId: 0,
            Name: null,
          },
        };
        $scope.fieldOptionList = [{
          Id: 0,
          Name: '',
          ProfileFieldId: 0,
        }, ];
        $scope.isEdit = false;
        $scope.isNew = false;
        $scope.customFieldDefs = [{
          id: 0,
          label: 'Custom Field 1',
        }, {
          id: 1,
          label: 'Custom Field 2',
        }, {
          id: 2,
          label: 'Custom Field 3',
        }, {
          id: 3,
          label: 'Custom Field 4',
        }, {
          id: 4,
          label: 'Custom Field 5',
        }, {
          id: 5,
          label: 'Custom Field 6',
        }, {
          id: 6,
          label: 'Custom Field 7',
        }, {
          id: 7,
          label: 'Custom Field 8',
        }, {
          id: 8,
          label: 'Custom Field 9',
        }, {
          id: 9,
          label: 'Custom Field 10',
        }, ];
        //executes when controller loads
        (function init() {
          if ($state.current.name === 'app.profileField') {
            setGridData();
            storage.removeItem('editProfileFieldData');
          } else if ($state.current.name === 'app.editProfileField') {
            if (storage.getItem('editProfileFieldData')) {
              $scope.profileField = Object.assign($scope.profileField, localLoad());
              $scope.fieldOptionList = $scope.profileField.fieldOptionList;
            } else {
              const warn = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>No profile field is selected.</p>`;
                  $scope.errTitle = 'Error';
                },],
              });
              warn.closePromise.then(function(data) {
                $state.go('app.profileField');
              });
            }
          }
        })();
        $scope.localSave = function() {
          const selectedRow = $scope.gridApi.selection.getSelectedRows()[0];
          const saveObject = {
            Id: selectedRow.Id,
            OrganizationId: selectedRow.OrganizationId,
            ProfileFieldName: selectedRow.AgencyDefinition,
            GdsFieldName: selectedRow.Name,
            ProfileColumn: selectedRow.Column,
            IsRequired: selectedRow.IsRequired,
            fieldOptionList: ((!!selectedRow.ProfileFieldOptions.length) ? selectedRow.ProfileFieldOptions : [{
              Id: 0,
              Name: '',
              ProfileFieldId: selectedRow.Id,
            }, ]),
          };
          storage.setItem('editProfileFieldData', JSON.stringify(saveObject));
        };

        function localLoad() {
          return JSON.parse(storage.getItem('editProfileFieldData'));
        }
        $scope.view = function(rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.viewData.Id = selectedRow.Id;
            $scope.viewData.OrganizationId = selectedRow.OrganizationId;
            $scope.viewData.ProfileFieldName = selectedRow.AgencyDefinition;
            $scope.viewData.GdsFieldName = selectedRow.Name;
            $scope.viewData.ProfileColumn = selectedRow.Column;
            $scope.viewData.IsRequired = selectedRow.IsRequired;
            $scope.fieldOptionList = selectedRow.ProfileFieldOptions;
            const view = ngDialog.open({
              template: 'templates/partials/viewProfileField.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function(data) {
              $scope.viewData = {};
              $scope.fieldOptionList = {};
            });
          }
        };
        $scope.selectProfileColumn = function() {
          if ($scope.formData.ProfileColumn) {
            $scope.validate.ProfileColumn = false;
          } else if ($scope.profileField.ProfileColumn) {
            $scope.validate.ProfileColumn = false;
          }
        };
        $scope.addProfileField = function () {
          if ($scope.formData.ProfileFieldName && $scope.formData.GdsFieldName && $scope.formData.ProfileColumn) {
            progress.start();
            $scope.formData.OrganizationId = clientSelectService.getSelectedClient().id;
            const promisePost = profileFieldService.addProfileField($scope.formData);
            let fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
              return (!!fieldOption.Name);
            });
            promisePost.then(function (profileFieldData) {
              if (!!fieldOptionList.length) {
                let promisePostFieldOption = profileFieldService.addProfileFieldOption(profileFieldData.data.Id,
                  fieldOptionList);
                promisePostFieldOption.then(function () {
                  const dialogPost = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Add Profile Field Success';
                      $scope.successMsg = 'Field name successfully created.';
                    },],
                  });
                  dialogPost.closePromise.then(function (data) {
                    $scope.clearAll();
                    $state.go('app.profileField');
                  });
                }, function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                        $scope.errTitle = 'Add Profile Field Error';
                      },],
                    });
                  }
                })
                  .finally(function () {
                    progress.complete();
                  });
              } else {
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Add Profile Field Success';
                    $scope.successMsg = 'The profile field has been added succesfully.';
                  },],
                });
                dialog.closePromise.then(function (data) {
                  $scope.formData.ProfileFieldName = '';
                  $scope.formData.GdsFieldName = '';
                  $scope.formData.ProfileColumn = '';
                  $scope.formData.IsRequired = false;
                  $state.go('app.profileField');
                });
              }
            }, function (err) {
              if (err.status != 401) {
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'Add Profile Field Error';
                  },],
                });
                dialog.closePromise.then(function (data) { });
              }
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            if (!$scope.formData.ProfileFieldName) {
              $scope.validate.ProfileFieldName = true;
            }
            if (!$scope.formData.GdsFieldName) {
              $scope.validate.GdsFieldName = true;
            }
            if (!$scope.formData.ProfileColumn) {
              $scope.validate.ProfileColumn = true;
            }
          }
        };
        // For updateProfileField, check ProfileColumn against null because id of custom field is given as integer --
        // if custom field 1 is chosen, the expression (!0) yields true, which results in a false positive for validation.
        $scope.updateProfileField = function () {
          if ($scope.profileField.ProfileFieldName && $scope.profileField.GdsFieldName && ($scope.profileField.ProfileColumn !=
            null)) {
            progress.start();
            const promisePut = profileFieldService.updateProfileField($scope.profileField);
            let fieldOptionList = $scope.fieldOptionList.filter(function (fieldOption) {
              return (!!fieldOption.Name);
            });
            promisePut.then(function () {
              if (!!fieldOptionList.length) {
                let promisePutFieldOption = profileFieldService.updateProfileFieldOption($scope.profileField.Id,
                  fieldOptionList);
                promisePutFieldOption.then(function () {
                  const dialogPut = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Update Profile Field Success';
                      $scope.successMsg = 'Field name successfully updated.';
                    },],
                  });
                  dialogPut.closePromise.then(function (data) {
                    $state.go('app.profileField');
                  });
                }, function (err) {
                  if (err.status != 401) {
                    ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                        $scope.errTitle = 'Edit Profile Field Error';
                      },],
                    });
                  }
                })
                  .finally(function () {
                    progress.complete();
                  });
              } else {
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Edit Profile Field Success';
                    $scope.successMsg = 'The profile field has been edited succesfully.';
                  },],
                });
                dialog.closePromise.then(function (data) {
                  $scope.profileField = {};
                  $scope.fieldOptionList = {};
                  $state.go('app.profileField');
                });
              }
            }, function (err) {
              if (err.status != 401) {
                $scope.editProfileFieldError = err.statusText + ": " + err.data;
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${editProfileFieldError}</p>`;
                    $scope.errTitle = 'Edit Profile Field Errorr';
                  },],
                });
                dialog.closePromise.then(function (data) {
                  $scope.editProfileFieldError = '';
                });
              }
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            if (!$scope.profileField.ProfileFieldName) {
              $scope.validate.ProfileFieldName = true;
            }
            if (!$scope.profileField.GdsFieldName) {
              $scope.validate.GdsFieldName = true;
            }
            if ($scope.profileField.ProfileColumn == null) {
              $scope.validate.ProfileColumn = true;
            }
          }
        };
        $scope.deleteProfileField = function() {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Profile Field?';
              $scope.strMsg = 'Do you really want to delete this profile field?';
            },],
          });
          confirm.closePromise.then(function(data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              profileFieldService.deleteProfileField($scope.rowSelectingId).then(function(response) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Delete Profile Field Success';
                      $scope.successMsg = 'The profile field has been succesfully deleted.';
                    },],
                  });
                  dialog.closePromise.then(function(data) {});
                }, function(err) {
                  if (err.status != 401) {
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                        $scope.errTitle = 'Delete Profile Field Error';
                      },],
                    });
                    dialog.closePromise.then(function(data) {});
                  }
                })
                .finally(function() {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        // Begin ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        // ui-grid options
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          enableColumnResizing: true,
          columnDefs: [{
            name: 'AgencyDefinition',
            visible: true,
            displayName: 'Agency Definition',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Name',
            visible: true,
            displayName: 'Profile field Name',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'IsRequired',
            visible: true,
            displayName: 'Required Field',
            enableHiding: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Column',
            visible: true,
            displayName: 'Custom Field',
            enableHiding: true,
            enableSorting: false,
            enableFiltering: false,
            cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setCustomField(row.entity.Column)}}</div>',
            enableColumnResizing: true,
            maxWidth: 230,
          }, {
            name: 'ProfileFieldOptions',
            visible: true,
            displayName: 'Field Option',
            enableHiding: false,
            enableSorting: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: false,
            cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setFieldOptions(row.entity.ProfileFieldOptions)}}</div>',
            enableColumnResizing: true,
          }, ],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
          onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            // Row Selection
            gridApi.selection.on.rowSelectionChanged($scope, function(row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
            // Grid Pagination
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              updateGridPagination();
            });
          },
        }; // End ui-grid option
        $scope.onDblClick = function(row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view(row.entity);
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }
        //Begin function to set ui-grid data
        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if (validateOrganization()) {
              progress.start();
              // get profile fields data
              getProfileFields().then(function(response) {
                if (response) {
                  //assign fields to ui grid
                  $scope.gridOptions.data = [];
                  $scope.gridOptions.totalItems = 0;
                  $scope.gridData = response;
                  updateGridPagination();
                }
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Profile Field Error';
                    },],
                  });
                }
              }).finally(function() {
                progress.complete();
              });
            }
          } else {
            if (valid.agencyValid === false) {
              //toastFactory.toast_info('Please select an agency and a client.');
            } else {
              //toastFactory.toast_info('Please select a client.');
            }
          }
        };
        $scope.setFieldOptions = function(optionList) {
          let optionName = '';
          optionName = optionList.reduce(function(option, name) {
            return option += name.Name + ' , ';
          }, optionName);
          return optionName.substring(0, optionName.length - 2);
        };
        $scope.clearAll = function() {
          $scope.profileField = {};
          $scope.isEdit = false;
          $scope.isNew = false;
          $scope.organizationSelId = null;
          $scope.fieldOptionList = [{
            Id: 0,
            Name: '',
            ProfileFieldId: 0,
          }, ];
        };
        $scope.addFieldOption = function() {
          $scope.fieldOptionList.push({
            Id: 0,
            Name: '',
            ProfileFieldId: $scope.profileField.Id,
          });
        };
        $scope.removeFieldOption = function(index, optionId) {
          if (!!optionId) {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Delete field option?';
                $scope.strMsg = 'Do you really want to delete this field option?';
              },],
            });
            confirm.closePromise.then(function(data) {
              if (data.value === 1) {
                profileFieldService.deleteProfileFieldOption(optionId).then(function(del) {
                    const dialogDel = ngDialog.open({
                      template: 'templates/partials/viewSuccessMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.strTitle = commonDialogMessage.fieldOptionDeletedMessage;
                        $scope.successMsg = 'Delete Profile Field Success';
                      },],
                    });
                    dialogDel.closePromise.then(function(data) {
                      $scope.fieldOptionList.splice(index, 1);
                      if ($scope.fieldOptionList.length == 0) {
                        $scope.fieldOptionList.push({
                          Id: 0,
                          Name: '',
                          ProfileFieldId: $scope.profileField.Id,
                        });
                      }
                    });
                  }, function(err) {
                    if (err.status != 401) {
                      ngDialog.open({
                        template: 'templates/partials/viewErrorMsg.html',
                        className: 'ngdialog-theme-plain',
                        controller: ['$scope', function ($scope) {
                          $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                          $scope.errTitle = 'Remove Profile Field Error';
                        },],
                      });
                    }
                  })
                  .finally(function() {
                    progress.complete();
                  });
              }
            });
          } else {
            if ($scope.fieldOptionList.length > 1) {
              $scope.fieldOptionList.splice(index, 1);
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>At least 1 field option is required.</p>`;
                  $scope.errTitle = 'Profile Field Required Message';
                },],
              });
            };
          };
        };
        $scope.setCustomField = function(column) {
          let customField = '';
          switch (column) {
            case 0:
              customField = 'Custom Field 1';
              break;
            case 1:
              customField = 'Custom Field 2';
              break;
            case 2:
              customField = 'Custom Field 3';
              break;
            case 3:
              customField = 'Custom Field 4';
              break;
            case 4:
              customField = 'Custom Field 5';
              break;
            case 5:
              customField = 'Custom Field 6';
              break;
            case 6:
              customField = 'Custom Field 7';
              break;
            case 7:
              customField = 'Custom Field 8';
              break;
            case 8:
              customField = 'Custom Field 9';
              break;
            case 9:
              customField = 'Custom Field 10';
              break;
            case 0:
              customField = 'Custom Field 1';
              break;
          }
          return customField;
        };

        function updateGridPagination() {
          let firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
          $scope.gridOptions.data = $scope.gridData.slice(firstRow, firstRow + paginationOptions.pageSize);
          $scope.gridOptions.totalItems = $scope.gridData.length;
          if ($scope.gridOptions.totalItems < 1) {
            //\\toastFactory.toast_warn(commonDialogMessage.profilesDashBoardNoResultMessage);
          }
        };

        function getProfileFields() {
          let organization = clientSelectService.getSelectedClient();
          return profileFieldService.getProfileFieldsByOrgId(organization.id).then(function(response) {
            return response.data;
          }, function(err) {});
        };
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            setGridData();
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/profileFieldsController.js